import { h } from 'preact';
import * as styles from './pill.scss';
import { clsx } from 'clsx';

interface Props {
  text: string;
  onClick: () => void;
  isActive: boolean;
}
export const Pill = ({ text, onClick, isActive }: Props): h.JSX.Element => {
  return (
    <button className={clsx(styles.pill, isActive ? styles.active : '')} onClick={onClick}>
      <span className={styles.buttonInnerSpan}>{text}</span>
    </button>
  );
};
